import { Theme } from '@mui/material/styles';
//
import { CloseIcon } from './CustomIcons';

declare module '@mui/material/Chip' {
  interface ChipPropsColorOverrides {
    tertiary: true;
    tertiaryLight: true;
  }
}

// ----------------------------------------------------------------------

export default function Chip(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: <CloseIcon />,
      },

      styleOverrides: {
        root: {
          '&.rounded': {
            borderRadius: 10,
          },
        },
        colorDefault: {
          '& .MuiChip-avatarMedium, .MuiChip-avatarSmall': {
            color: theme.palette.text.secondary,
          },
        },
        colorTertiary: {
          backgroundColor: theme.palette.tertiary.lighter,
          color: isLight ? theme.palette.tertiary.dark : theme.palette.tertiary.main,
        },
        colorTertiaryLight: {
          backgroundColor: theme.palette.tertiaryLight.lighter,
          color: isLight ? theme.palette.tertiaryLight.dark : theme.palette.tertiaryLight.main,
        },
        outlined: {
          borderColor: theme.palette.grey[500_32],
          '&.MuiChip-colorPrimary': {
            borderColor: theme.palette.primary.main,
          },
          '&.MuiChip-colorSecondary': {
            borderColor: theme.palette.secondary.main,
          },
          '&.MuiChip-colorTertiary': {
            borderColor: theme.palette.tertiary.main,
            color: theme.palette.tertiary.main,
          },
          '&.MuiChip-colorTertiaryLight': {
            borderColor: theme.palette.tertiaryLight.main,
            color: theme.palette.tertiaryLight.main,
          },
        },
        //
        avatarColorInfo: {
          color: theme.palette.info.contrastText,
          backgroundColor: theme.palette.info.dark,
        },
        avatarColorSuccess: {
          color: theme.palette.success.contrastText,
          backgroundColor: theme.palette.success.dark,
        },
        avatarColorWarning: {
          color: theme.palette.warning.contrastText,
          backgroundColor: theme.palette.warning.dark,
        },
        avatarColorError: {
          color: theme.palette.error.contrastText,
          backgroundColor: theme.palette.error.dark,
        },
        avatarColorTertiary: {
          color: theme.palette.tertiary.contrastText,
          backgroundColor: theme.palette.tertiary.dark,
        },
        avatarColorTertiaryLight: {
          color: theme.palette.tertiaryLight.contrastText,
          backgroundColor: theme.palette.tertiaryLight.dark,
        },
      },
    },
  };
}
